module.exports = __webpack_public_path__ + "img/about2.7968ed0e.jpg";